// src/utils/tdeeCalculator.js
// Mifflin-St Jeor equation + activity multipliers

const ACTIVITY_MULTIPLIERS = {
  sedentary:   1.2,
  light:       1.375,
  moderate:    1.55,
  active:      1.725,
  very_active: 1.9,
};

/**
 * Calculate TDEE using Mifflin-St Jeor equation.
 * @param {object} params
 * @param {number} params.weight_lbs
 * @param {number} params.height_inches
 * @param {number} params.age
 * @param {"male"|"female"} params.sex
 * @param {string} params.activity_level
 * @returns {number} TDEE in calories/day (rounded)
 */
export function calculateTDEE({ weight_lbs, height_inches, age, sex, activity_level }) {
  const weight_kg  = weight_lbs * 0.453592;
  const height_cm  = height_inches * 2.54;
  const sexOffset  = sex === "male" ? 5 : -161;

  const bmr  = (10 * weight_kg) + (6.25 * height_cm) - (5 * age) + sexOffset;
  const mult = ACTIVITY_MULTIPLIERS[activity_level] ?? 1.55;

  return Math.round(bmr * mult);
}

/**
 * Recalculate TDEE when user updates their profile.
 */
export function recalculateTDEE(profile) {
  return calculateTDEE({
    weight_lbs:     profile.weight_start,
    height_inches:  profile.height_inches,
    age:            profile.age,
    sex:            profile.sex,
    activity_level: profile.activity_level,
  });
}
